module.exports = __webpack_public_path__ + "static/media/Best Flour.b28e3f12.png";